<template>
  <div>
    <el-card shadow="always">
      <edit-form
        ref="editForm"
        :disabled="disabled"
        :tcFabricSalesCode="params.code"
        :tcFabricPurchaseCode="query.tcFabricPurchaseCode"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import { mapActions } from 'vuex'
export default {
  name: 'tc-fabricSell-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    if (this.pageType !== 'add') return
    if (this.params.code || !this.query.tcFabricPurchaseCode) {
      this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    }
  },
  methods: { ...mapActions('admin/page', ['close']) },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
